/* 🤖 this file was generated by svg-to-ts */
export const DfIconThumbsUp12: {
  name: 'thumbs-up-12';
  data: string;
} = {
  name: 'thumbs-up-12',
  data: `<svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path d="M5.948 11c-.125 0-.249-.021-.367-.063l-.781-.278c-.478-.17-.8-.648-.8-1.186V5.028c0-.24.064-.474.185-.676l1.84-3.065a.56.56 0 0 1 .795-.196l.333.218c.209.137.316.399.268.656L7.036 4.09c-.06.339.146.667.462.733l.043.007 2.593.325c.497.076.866.532.866 1.07v.739c0 .131-.02.262-.057.387l-.847 2.787c-.157.515-.605.863-1.11.863zm-4.281-1C1.298 10 1 9.731 1 9.4V4.6c0-.331.298-.6.667-.6h.666c.369 0 .667.269.667.6v4.8c0 .331-.298.6-.667.6z"/></svg>`
};
